import React, {useContext,useEffect,useState} from 'react'
import { formularioContext } from '../contextos/FormularioContext'
import { ArrowDownIcon } from '@heroicons/react/16/solid';
import {useParams} from 'react-router-dom'
import {Card, CardHeader, CardActions, CardContent,Typography, Button, Alert, Box,Grid,CardMedia, List} from '@mui/material'
import Axios from 'axios'
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import {ETSolicitaDatosPersona} from './ETSolicitaDatosPersona'
import {useHelper} from '../hooks/useHelper'
import {ETNuevaInscripcion} from './ETNuevaInscripcion'

export const ETInscripcion = ({eventoValor,cancelar,target})=>{
    const {validarMinistroEventoSeleccionado,datos,
        datosMinistroOk} = useContext(formularioContext)
    const [datosMinistroUad,setDatosMinistroUad]= useState(null)
    const [pabloStolarczuk,setPabloStolarczuk] = useState(false)
    const {rangoEdadEvento,formatearMontoMoneda} = useHelper()  

    return <Box sx={{textAlign:'left',p:2,background:'orange',backgroundColor:'white'}}>
        <Typography id="atention"  variant="h5">{eventoValor?.detalle}</Typography>
        <Typography onDoubleClick={()=>setPabloStolarczuk(!pabloStolarczuk)} sx={{mt:2}} variant="h5" align="rigth" color="primary"             >
                {valorSegunCaso(eventoValor,validarMinistroEventoSeleccionado,target,formatearMontoMoneda)} 
        </Typography>
        <Typography variant="subtitle1">{eventoValor?.info_adicional}</Typography>
        <ul className="mt-4 list-disc list-inside">
            <li>{eventoValor.matrimonio ? 'Promo Matrimonio':'Entrada Individual'}</li>
            {rangoEdadEvento(eventoValor) && <li>{rangoEdadEvento(eventoValor)}</li>}
        </ul>
        <div style={{display:pabloStolarczuk ? 'block' : 'none'}}>
            <h1 className='text-lg'>Tipo de visitante: {datos.ministroUad}</h1>
            <Typography  variant="subtitle1">Tipo de público: {eventoValor?.tipo_persona}</Typography>
            <p>{rangoEdadEvento(eventoValor)}</p>
            <p>{eventoValor.matrimonio ? 'Promo Matrimonio':'Entrada Individual'}</p>
            <p>{eventoValor.validar_dni_externos ? 'validar_dni_externos':'NO validar_dni_externos'}</p>
            <p>Datos ministro 0k: {datosMinistroOk()[0] ? ' ok' :'mal'}</p>
            <p>Restriccion: {validarMinistroEventoSeleccionado(null,eventoValor)[1]}</p>
        </div>
        {eventoValor.tipo_persona != 'uad' && <BotonVolver cancelar={cancelar}/>}
        <ETSolicitaDatosPersona tipoItemPersona={eventoValor.tipo_persona}/>
        {eventoValor.tipo_persona == 'uad' && <BotonVolver cancelar={cancelar}/>}
       {datos.ministroUad && <ETNuevaInscripcion id_evento={eventoValor.id_evento}  eventoValorSeleccionado={eventoValor} cancelar={cancelar}/>}
    </Box>
}

const valorSegunCaso = (eventoValor,validarMinistroEventoSeleccionado,target,formatearMontoMoneda)=>{
    if(target=='all'){
        const estadoEsValido = validarMinistroEventoSeleccionado(null,eventoValor)[0];
        return estadoEsValido ? formatearMontoMoneda(eventoValor.valor_mp): ''
    }else{
        return formatearMontoMoneda(eventoValor.valor_mp)
    }
}

const BotonVolver = ({cancelar})=>{
    return <Button sx={{mt:2,mb:2}} title='Cerrar y volver a otras opciones de inscripción' variant='outlined' onClick={cancelar}>VOLVER AL INICIO</Button>
}